
export default {
  name: "cal-star-reviews-section",
  data() {
    return {
      numberOfStars: 5,
    };
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    colour: {
      type: String,
      default: "text-primary",
    },
    starSize: {
      type: String,
      default: "w-[1.3rem] sm:w-[1.5rem]",
    },
    hideRating: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    scrollToDiv() {
      // Get the target div by ID
      const targetDiv = document.getElementById(this.id);

      // Check if the target div exists
      if (targetDiv) {
        // Use the smooth scroll behavior
        targetDiv.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
